import type { LanguageDetectionOptions } from './types/languageDetectionOptions';

export const languageDetectionOptions: LanguageDetectionOptions = {
  order: ['path', 'localStorage', 'navigator'],
  lookupFromPathIndex: 0,
  lookupLocalStorage: 'sm-ui-language',
  caches: ['localStorage'],
};

export enum AvailableLanguages {
  en = 'en',
  nb = 'nb',
  fi = 'fi',
}

export const languageLabels: Record<AvailableLanguages, string> = {
  en: 'English',
  nb: 'Norsk',
  fi: 'Suomeksi',
};

const isAvailableLanguage = (value?: string | null): value is AvailableLanguages =>
  Boolean(value) &&
  Object.values(AvailableLanguages).includes(value as AvailableLanguages);

const internalFallbackLanguage = AvailableLanguages.en;

const envFallbackLanguage =
  import.meta.env.REACT_APP_FALLBACK_LANGUAGE?.trim().toLowerCase();

const envLanguages = import.meta.env.REACT_APP_UI_LANGUAGES?.split(',')
  .map((value: string) => value.trim().toLowerCase())
  .filter(isAvailableLanguage);

export const fallbackLanguage: AvailableLanguages = isAvailableLanguage(
  envFallbackLanguage,
)
  ? envFallbackLanguage
  : internalFallbackLanguage;

export const supportedLanguages: AvailableLanguages[] =
  envLanguages && envLanguages.length > 0
    ? Array.from(new Set(envLanguages))
    : [fallbackLanguage];

export const isSupportedLanguage = (
  value?: string | null,
): value is AvailableLanguages =>
  Boolean(value) && supportedLanguages.includes(value as AvailableLanguages);
